import { cn } from 'lib/utils'

interface SkeletonProps extends React.ComponentProps<'div'> {
  /** `default` — legacy `bg-accent`. `dark` — T3 dual-theme (`bg-bg-3`, hairline border). */
  variant?: 'default' | 'dark'
}

function Skeleton({ className, variant = 'default', ...props }: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'animate-pulse',
        variant === 'default' && 'rounded-md bg-accent',
        variant === 'dark' && 'rounded-[8px] border border-line bg-bg-3',
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
